export const productTypes = [
  {
    id: "vegetables",
    title: "Овочі",
  },
  {
    id: "fruits",
    title: "Фрукти",
  },
  {
    id: "green",
    title: "Зелень",
  },
];
